<template>
  <div class="hello">
    <!-- <common-header></common-header> -->
    <!-- <header></header> -->
    <Header :items="this.$host.items"/>
    <full-page :options="options" ref="fullpage" id="fullpage">
      <div class="section animated bounceInDown" id="first">
        <section-one></section-one>
      </div>
      <div class="section animated bounceInLeft" id="second">
        <section-two></section-two>
      </div>
      <div class="section animated bounceInLeft" id="third">
        <section-three></section-three>
      </div>
      <div class="section footerH" id="fourth">
        <section-foot></section-foot>
      </div>
    </full-page>
    <!-- <div class="downarrow">
      <img src="@/assets/images/icon_next.png" alt="">
    </div> -->
  </div>
</template>

<script>
import "@/assets/css/fullpage.min.css" //引入该css会导入下面背景图消失
// import first from "@/assets/images/banner_1.jpg"
// import second from "@/assets/images/banner_2.jpg"
// import third from "@/assets/images/banner_3.jpg"
// import fourth from "@/assets/images/banner_4.jpg"
import $ from "jquery";
// 以上四张图作为轮播图插入备用
// import CommonHeader from "../../common/header/Header"
import Header from '../header/app-header'
import SectionOne from './components/SectionOne'
import SectionTwo from "./components/SectionTwo"
import SectionFoot from './components/SectionFoot'
import SectionThree from './components/SectionThree'

export default {
  name: "Home",
  components: {
    // CommonHeader,
    Header,
    SectionOne,
    SectionTwo,
    SectionThree,
    SectionFoot
  },
  data() {
    return {
      options: {
        //整屏插件vue-fullpage选项
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        verticalCentered: true, //定义每一页的内容是否垂直居中
        afterLoad: this.afterLoad, //滚动到某一屏后的回调函数 // scrollOverflow: true,//内容超过满屏后显示滚动条
        controlArrows: false, //是否通过箭头控制slide幻灯片
        loopHorizontal: true, //slide幻灯片是否循环滚动
        scrollBar: true, //true则是一滚动就是一整屏
        scrollingSpeed: 800,
        onLeave: this.onLeave, //滚动前的回调函数，
        menu: true,
        anchors: ["firstPage", "secondPage", "thirdPage", "fourthPage"],
        sectionsColor: ["first", "second", "third", "fourth"],
        navigation: true,
        navigationPosition: "right",
        navigationColor: "#f00",
        navigationTooltips: ["首页", "解决方案", "入驻流程", "展示案例"],
        slidesNavigation: true,
        controlArrowColor: "#fff",
        // loopBottom: true,
        autoScrolling: true,
        css3: true,
        keyboardScrolling: true
      },
      timer: "" //定时器 -- 全局变量
    };
  },
  methods: {
    // moveSlideRight() {
    //   // 第一屏轮播图
    //   this.timer = setInterval(() => {
    //     this.$refs.fullpage.api.moveSlideLeft();
    //   }, 3000); //此处只能用箭头函数，用function会不执行
    // },
    //滚动到某一屏之后的函数
    afterLoad: function(anchors, item) {
      // alert(item.index);
      //  $('.nav li a').removeClass('active')
       let index = item.index;
      if (index === 0) {
        // $('.nav li a').eq(index).addClass('active')
        setTimeout(() => {
          $(".title").eq(index).addClass("current")
        },1000)
      } else if (index === 1) {
        // $('.nav li a').eq(index).addClass('active')
        setTimeout(() => {
          $(".sectionTwo").addClass("current")
          $('.container-img').addClass('current')
        }, 500)
      } else if (index === 2) {
        // $('.nav li a').eq(index).addClass('active')
        setTimeout(() => {
          $('.container-img .first').addClass('current')
        },500)
        setTimeout(() => {
          $('.container-img .second').addClass('current')
        },1000)
        setTimeout(() => {
          $('.container-img .third').addClass('current')
        },2000)
      } else if(index === 3){
        // $('.nav li a').eq(index).addClass('active')
        setTimeout(() => {
          $('.title').addClass('current');
        },1000)
      }
    },
    //滚动到某一屏之前的回调函数
    onLeave: function() {
      setTimeout(() => {
        $(".title").removeClass("current")
        $(".sectionTwo").removeClass("current")
        $('.container-img').removeClass('current')
        $('.container-img .con-img').removeClass('current')
        $('.title').removeClass('current')
      },1000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
/* #fullpage{
  overflow:hidden;
} */

.footerH{
  width:100%;
  height:100%;
}
#fp-nav ul li a.active span,
.fp-slidesNav ul li a.active span {
  background: #fff !important; /*这里设置的是活动导航的颜色*/
}
#fp-nav ul li a span,
.fp-slidesNav ul li a span {
  border: 1px solid #fff !important; /*这里设置的是非活动导航的颜色*/
}
.downarrow {
  position: fixed;
  bottom:69px;
  width: 100%;
  height: 50px;
  display:flex;
  justify-content: center;
  align-items:center;
  cursor: pointer;
}
.downarrow img{
  width:34px;
  height:20px;
}
</style>
